import { toastController } from "@ionic/core";

export const toast = async (options: { message: string; duration?: number; color?: string }): Promise<void> => {
  options.duration = options.duration || 3000;
  options.color = options.color || "danger";
  const t = await toastController.create(options);
  return t.present();
};
